module.exports = __webpack_public_path__ + "static/cpr-a74a64047f028e6653928bb534412f75.png";